module.exports = __webpack_public_path__ + "img/PS26.48d64a1b.png";